import { CustomizedServiceRequest } from '../model/customizedServiceRequest';
export class CustomizedServiceRequestBuilder {
    static buildCustomizedServiceRequest(data) {
        const customizedServiceRequest = new CustomizedServiceRequest();
        customizedServiceRequest.id = data.id;
        customizedServiceRequest.status = data.status;
        customizedServiceRequest.date_created = data.date_created;
        customizedServiceRequest.id_client = data.id_client;
        customizedServiceRequest.id_via = data.id_via;
        customizedServiceRequest.id_reservation = data.id_reservation;
        customizedServiceRequest.id_vehicle = data.id_vehicle;
        customizedServiceRequest.id_mechanical_order = data.id_mechanical_order;
        customizedServiceRequest.name = data.name;
        customizedServiceRequest.phone = data.phone;
        customizedServiceRequest.email = data.email;
        customizedServiceRequest.data = data.data;
        return customizedServiceRequest;
    }
}
//# sourceMappingURL=customizedServiceRequest-builder.js.map